import React, { PropTypes, PureComponent } from 'react';
import { hashHistory } from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import messages from './i18n';
import styles from './styles.scss';
import { AnimatedTick } from '../shared';

export class SignUpConfirmation extends PureComponent {
  componentDidMount() {
    setTimeout(hashHistory.push, 6800, '/info');
  }

  render() {
    return (
      <div className={styles.view}>
        <div className={cn(styles.container, styles.confirmationContainer)}>
          <AnimatedTick
            className={styles.confirmationTick}
          />
          <h2 className={cn(styles.heading, styles.confirmationText)}>
            <FormattedMessage {...messages.welcome} />
          </h2>
        </div>
        <div className={cn(styles.container, styles.howToContainer)}>
          <h2 className={cn(styles.heading, styles.howToText)}>
            <FormattedMessage {...messages.carouselContext} />
          </h2>
        </div>
      </div>
    );
  }
}

SignUpConfirmation.propTypes = {
  account: PropTypes.object,
};

export default injectIntl(SignUpConfirmation);



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_confirmation/index.jsx